















































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {UserStore} from '@/store/user-module';
import {getHours, padZero} from '@/utlitities/helper';

@Component({
  components: {
  },
})
export default class StTimePickerPopover extends Vue {
  @Prop() value!: string;
  @Prop() focus!: boolean;
  @Prop() hourPart!: string;
  @Prop() minutePart!: string;
  @Prop() minutes!: string[];
  @Prop() hours!: string[];

  get userSettings() {
    return UserStore.userSettings;
  }

  changeMinutes(interval: number) {
    let minute = parseInt(this.minutePart, 10);

    minute += interval;

    if (minute > 59) {
      minute = 59;
    }

    if (minute < 0) {
      minute = 0;
    }

    this.$emit('minuteChange', padZero(minute));
  }

  parseMinutePart(strVal: string) {
    let intVal = parseInt(strVal, 10);

    if (!intVal) {
      this.minutePart = '00';
      return;
    }

    if (intVal > 59) {
      intVal = 59;
    }

    if (intVal < 0) {
      intVal = 0;
    }

    this.$emit('minuteChange', padZero(intVal));
  }

  parseMinutePartFromEvent(event: any) {
    let strVal = event.target.value;
    this.parseMinutePart(strVal);
  }

  @Emit('input')
  input(val: string) {
    return val;
  }
}
